import React from 'react';
import { UserProgressState, IUserStatusModel, AdditionalFilter } from './interface'
import ProfileServices from '../../Services/ProfileServices';
import { loadFromLocalStorage } from '../../Common/Validation/LocalStorage';
import { TableColumn } from 'react-data-table-component';
import DataGrid from '../../Components/DataGrid/DataGrid';
import Swal from 'sweetalert2';
import ViewUserProgress from './ViewUserProgress/ViewUserProgress';
import withReactContent from 'sweetalert2-react-content';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

import CustomMaterialMenu from '../../Components/DataGrid/Plugins/CustomMaterialMenu/CustomMaterialMenu';
import FormServices from '../../Services/FormServices';
import { IPopoverItemData } from '../../Components/DataGrid/Plugins/CustomMaterialMenu/Interface';
import moment from 'moment';
import CSEDDetails from '../CSEDDetails/CSEDDetails';
import { createRoot } from 'react-dom/client';
import EditTaxpayer from './EditTaxpayer/EditTaxpayer';
import { Select, MenuItem } from '@mui/material';
import './UserProgress.css';

const MySwal = withReactContent(Swal);

class UserProgress extends React.Component<{}, UserProgressState> {

    constructor(_props: any) {
        super(_props);
        this.state = {
            accessToken: '',
            currentPage: 1,
            currentRowsPerPage: 10,
            searchText: '',
            totalRows: 0,
            currentSortColumn: '',
            sortingDirection: '',
            userDetails: [],
            additionalFilter: {
                formName: '',
                value: ''
            },
            selectedAccount: "1", // Default account type is Resolution (on page load)
            tenantIndex: 1
        }

    }

    private formColumns: TableColumn<IUserStatusModel>[] = [
        {
            name: 'Taxpayer Name',
            selector: (row: IUserStatusModel) => row.userName,
            sortable: true,
        },
        {
            name: 'Email',
            selector: (row: IUserStatusModel) => row.email,
            sortable: true,
        },
        {
            name: 'Mobile Number',
            selector: (row: IUserStatusModel) => row.mobileNumber,
            sortable: true,

        },
        {
            name: 'Persona Id',
            selector: (row: IUserStatusModel) => row.personaInqId,
            sortable: true,
            id: "personaId",
            cell: (row: IUserStatusModel) => (
                row.personaInqId ? (
                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                        <a
                            href={`https://app.withpersona.com/dashboard/inquiries/${row.personaInqId}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {row.personaInqId}
                        </a>
                        {/* <FaRegCopy
                            style={{ cursor: "pointer", color: "#007bff" }}
                            onClick={() => copyToClipboard(row.personaInqId)}
                            title="Copy to clipboard"
                        /> */}
                    </div>
                ) : <span>-</span>
            ),
            minWidth: "200px",
            maxWidth: "250px",
            center: true,
            wrap: true
        },
        {
            name: 'Form Submission',
            cell: (row: IUserStatusModel) =>
                <div className='resub-container'
                    onClick={() => { this.viewUserPopup(row) }}>
                    <div className={`Form8821-resub-icon ${row.actionRequired ? '' : 'disabled'}`}>
                        <WarningAmberIcon />
                    </div>
                    <div className={`Form8821-resub-text ${row.actionRequired ? '' : 'disabled'}`}>
                        <span> Action Needed </span>
                    </div>
                </div>,
            sortable: true,
            minWidth: "200px",
        },
        {
            name: 'Date',
            //selector: row => moment(row.payment_time).format('MM-DD-YYYY hh:mm A'),//hh:mm A on Do MMMM YYYY
            selector: (row: IUserStatusModel) => row.registeredDate ? moment(row.registeredDate).format('MM-DD-YYYY hh:mm A') : '-',//hh:mm A on Do MMMM YYYY
            sortable: true,
            center: true,

        },
        {
            name: 'Action',
            cell: (row: IUserStatusModel) => <button
                className='download-form-Btn'
                onClick={(event) => {
                    this.activateOrDeactivateUser(row);
                }}>
                Deactivate
            </button>,
            allowOverflow: false,

            button: true,
        },
        {
            cell: (row) => {
                let menu: IPopoverItemData[] = [
                    {
                        key: "form8821",
                        label: "Submitted Form-8821 to IRS",
                        disabled: ((row.form8821Docusign && (row.isForm8821Approved || row.isForm8821Submitted)) && !(row.form8821ResubFlag && row.isForm8821Submitted && row.form8821Docusign)) || !row.form8821Docusign,
                        textStyle: ((row.form8821Docusign && (row.isForm8821Approved || row.isForm8821Submitted)) && !(row.form8821ResubFlag && row.isForm8821Submitted && row.form8821Docusign)) || !row.form8821Docusign ? 'cv-disabled' : ''
                    },
                    {
                        key: "dashboard",
                        label: "Dashboard & Report",
                        disabled: !row.isForm8821Approved,
                        textStyle: !row.isForm8821Approved ? 'cv-disabled' : ''

                    }
                ];

                if (!row.isSubscriptionCompleted) {
                    menu.push(
                        {
                            key: "sixMonthZeroSubscription",
                            label: "6-Month Free Subscription"
                        },
                        {
                            key: "thirtyDaysZeroSubscription",
                            label: "30 days Free Subscription"
                        }
                    )
                }
                else {
                    menu.push(
                        {
                            key: "cancelSubscription",
                            label: "Cancel Subscription"
                        }
                    )
                }

                if (row.personaInqId) {
                    menu.push(
                        {
                            key: "editTaxpayerName",
                            label: "Edit Taxpayer Name"
                        }
                    );
                }
                return <CustomMaterialMenu
                    fontSize="small"
                    multiPopoverItems={menu}
                    onPopoverClick={(key_: string, label_: string) => {
                        console.log(key_);
                        if (key_ == "form8821") this.updateFormSubmission(row.userId, key_);
                        if (key_.toLocaleLowerCase().indexOf("subscription") != -1) this.updateSubscription(row.userId, (key_.toLocaleLowerCase().indexOf("zerosubscription") != -1), key_);
                        if (key_ == "dashboard") {

                            Swal.fire({
                                title: 'Transcript Dashboard',
                                html: `<div id="csedd-details-root"></div>`,
                                width: '90%',
                                showCloseButton: true,
                                showConfirmButton: false,
                                allowOutsideClick: false,
                                didOpen: () => {
                                    const container = document.getElementById('csedd-details-root');
                                    if (container) {
                                        const root = createRoot(container);
                                        root.render(<CSEDDetails userId={row.userId} userName={row.userName} />);
                                    }
                                },
                                willClose: () => {
                                    const container = document.getElementById('csedd-details-root');
                                    if (container) {
                                        container.innerHTML = ''; // cleanup
                                    }
                                }
                            });
                            return
                        }
                        if (key_ == "editTaxpayerName") {
                            this.editTaxpayerNamePopup(row);
                        }
                    }}
                />
            },
            allowOverflow: true,
            button: true,
            width: '56px'
        }
    ]

    async componentDidMount() {
        ///... check token in local storage
        const accesstoken = await loadFromLocalStorage('accessToken');
        ///... if available get user details otherwise re-direct to login page
        if (accesstoken) {
            this.setState({
                accessToken: accesstoken.toString()
            }, () => {
                this.getAllUsers();
            });
        }
        else {
            localStorage.clear();
            window.location.href = '/'
        }

        const tenantData = JSON.parse(localStorage.getItem('TENANT_CONFIG') || '{}');
        this.setState({
            tenantIndex: tenantData?.tenant_index
        });
    }

    identifySortingMapColumn(columnName: string) {
        let actualColName = '';
        switch (columnName) {
            case "Taxpayer Name":
                actualColName = 'userName';
                break;
            case "Action":
                actualColName = 'actionRequired';
                break;
            case "Email":
                actualColName = 'email';
                break;
            case "Mobile Number":
                actualColName = 'mobileNumber';
                break;
        }
        return actualColName;
    }

    getAllUsers() {

        let pageIndex: number = (this.state.currentPage - 1);
        let sortingObj: any = {};
        if (this.state.currentSortColumn != '') {
            sortingObj['column'] = this.state.currentSortColumn;
            sortingObj['direction'] = this.state.sortingDirection;
        }
        let pagination: any = {
            "offset": (pageIndex * this.state.currentRowsPerPage),
            "limit": this.state.currentRowsPerPage,
            "sort": { ...sortingObj },
            "searchFilter": this.state.searchText,
            "additionalFilter": this.state.additionalFilter
        };

        ProfileServices.getUserProgress(pagination, this.state.accessToken, this.state.selectedAccount).then((r) => {
            if (r.ok) {
                r.json().then(resp => {
                    this.setState({ userDetails: resp.response, totalRows: resp.totalCount });
                });
            }
        });
    }

    viewUserPopup(_row: IUserStatusModel) {
        console.log(_row)
        MySwal.fire({
            title: 'User Progress',
            html: <ViewUserProgress detail={_row} accessToken={this.state.accessToken} />,
            showCloseButton: true,
        });
    }

    editTaxpayerNamePopup(row: IUserStatusModel) {
        MySwal.fire({
            title: `Edit Taxpayer Name`,
            html: <EditTaxpayer detail={row} accessToken={this.state.accessToken} onCompleteCallback={() => {
                this.getAllUsers(); // refresh after update
            }} />,
            showCloseButton: true,
            showConfirmButton: false
        });
    }

    activateOrDeactivateUser(row: IUserStatusModel) {
        let payload = {
            userId: row.userId
        };
        ProfileServices.updateUserStatus(payload, this.state.accessToken).then((r) => {
            if (r.ok) {
                r.json().then((resp) => {
                    this.getAllUsers();
                    Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: "Updated user status successfully",
                    });
                });
            }
        });

    }

    private updateFormSubmission(userId: string, key: string) {

        try {
            FormServices.updateFormSubmission({ userId: userId, formName: key }, this.state.accessToken).then(r => {

                if (r.ok) {
                    this.getAllUsers();
                    Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: `Updated IRS Submission for Form 8821 successfully`,

                    });
                }

            });
        }
        catch (ex) {
            ///... give swal error
        }

    }

    private updateSubscription(userId: string, isAdd_: boolean, key_: string) {

        try {
            let subscriptionDays = key_.indexOf('30') == -1 ? 180 : 30;
            FormServices.updateSubscription({ userId: userId, isAdd: isAdd_, days: subscriptionDays }, this.state.accessToken).then(r => {

                if (r.ok) {
                    this.getAllUsers();
                    Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: `Subscription ${isAdd_ ? "updated" : "cancelled"} successfully`,

                    });
                }

            });
        }
        catch (ex) {
            ///... give swal error
        }

    }

    public render() {
        return (
            <div className='body-sub-contianer table-container'>
                <Select
                    value={(this.state.tenantIndex === 2) ? '2' : this.state.selectedAccount} disabled={this.state.tenantIndex === 2}
                    onChange={(e) => {
                        const value = e.target.value;
                        this.setState({
                            selectedAccount: value,
                            currentPage: 1,
                            currentRowsPerPage: 10,
                            searchText: '',
                            totalRows: 0,
                            currentSortColumn: '',
                            sortingDirection: '',
                            userDetails: [],
                            additionalFilter: {
                                formName: '',
                                value: ''
                            }
                        }, () => {
                            this.getAllUsers();
                        });
                    }
                    }
                    sx={{
                        borderRadius: 3,
                        backgroundColor: '#fff',
                        fontWeight: 500,
                        boxShadow: '0px 2px 8px rgba(0,0,0,0.05)',
                        '& .MuiSelect-select': {
                            padding: '10px 14px',
                        },
                        '& fieldset': {
                            borderColor: '#e0e0e0',
                        },
                        '&:hover fieldset': {
                            borderColor: 'var(--secondary-main)',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: 'var(--secondary-main)',
                            borderWidth: '1px',
                        },
                    }}
                >
                    <MenuItem value="1">Resolution</MenuItem>
                    <MenuItem value="2">Kwong</MenuItem>
                </Select>
                <DataGrid
                    title='User Management'
                    search='User Details'
                    columns={this.formColumns}
                    data={this.state.userDetails}
                    onSearch={(searchText_: string) => {
                        this.setState({
                            searchText: searchText_,
                            currentPage: 1
                        }, () => {
                            this.getAllUsers();
                        })
                    }}
                    accountType={this.state.selectedAccount}
                    filter
                    onFilter={(additionalFilter: string) => {
                        this.setState({
                            additionalFilter: this.getAdditionalFilterDetails(additionalFilter),
                            currentPage: 1
                        }, () => {
                            this.getAllUsers();
                        })
                    }}
                    onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
                        this.setState({
                            currentPage: currentPage,
                            currentRowsPerPage: currentRowsPerPage
                        }, () => {
                            this.getAllUsers();
                        })
                    }}
                    onChangePage={(page: number, totalRows: number) => {
                        console.log(page, totalRows);
                        this.setState({
                            currentPage: page
                        }, () => {
                            this.getAllUsers();
                        })
                    }}

                    onRowClicked={(row: IUserStatusModel) => {

                        this.viewUserPopup(row);
                    }}
                    onSort={(column: any, direction) => {

                        this.setState({
                            currentSortColumn: this.identifySortingMapColumn(column.name),
                            sortingDirection: direction,
                            currentPage: 1
                        }, () => {
                            this.getAllUsers();
                        })
                    }}
                    pagination
                    paginationTotalRows={this.state.totalRows}
                />
            </div>
        )
    }

    private getAdditionalFilterDetails(filteredString: string) {

        switch (filteredString) {

            case 'subscriptionPending':
                return {
                    formName: 'subscription',
                    value: 'pending'
                };
            case 'subscriptionCompleted':
                return {
                    formName: 'subscription',
                    value: 'completed'
                };
            case 'personaPending':
                return {
                    formName: 'persona',
                    value: 'pending'
                };
            case 'personaCompleted':
                return {
                    formName: 'persona',
                    value: 'completed'
                };
            case 'form8821Signed':
                return {
                    formName: 'form8821Signed',
                    value: 'completed'
                };
            case 'form8821Submitted':
                return {
                    formName: 'form8821',
                    value: 'submitted'
                };
            case 'form8821Approved':
                return {
                    formName: 'form8821',
                    value: 'approved'
                };
            case 'financialsPending':
                return {
                    formName: 'financials',
                    value: 'pending'
                };
            case 'financialsCompleted':
                return {
                    formName: 'financials',
                    value: 'completed'
                };
            case 'form433APending':
                return {
                    formName: 'form433A',
                    value: 'pending'
                };
            case 'form433ACompleted':
                return {
                    formName: 'form433A',
                    value: 'completed'
                };
            case 'form433DApproved':
                return {
                    formName: 'form433D',
                    value: 'approved'
                };
            case 'form433DSubmitted':
                return {
                    formName: 'form433D',
                    value: 'submitted'
                };
            default:
                return {
                    formName: '',
                    value: ''
                }
        }

    }
}

export default UserProgress;